import {Container} from '@web-libs/ui/layout-components/container';
import {SplitLayout} from '@web-libs/ui/layout-components/split-layout';
import {PageContainer} from '@web-libs/ui/layout-components/page-container';
import {ReactNode} from 'react';
import cssStyles from './auth-page.module.css';
import ScrollContainer from '@web-libs/ui/layout-components/scroll-container/scroll-container';

export type AuthPageViewProps = {
    illustration: ReactNode,
    card: ReactNode;
}

export const AuthPageView = (props: AuthPageViewProps) => {

    return (
        <PageContainer className={cssStyles.authPage} fullscreen>
            <ScrollContainer style={{height: '100%'}}>
                <SplitLayout style={{flexGrow: 1, paddingBottom: '32px'}} rightFixed={750}>
                    <Container className={cssStyles.illustrationContainer} centerItems fullHeight padding={64}>
                        {props.illustration}
                    </Container>
                    {props.card}
                </SplitLayout>
            </ScrollContainer>
        </PageContainer>
    );
};
